import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  clientName: '',
  hasUsers: false,
  jurisdiction: [],
  healthCondition: [],
  sdohData: [],
  isCompleted: false,
  projectNamesList: [],
  navigationProps: [],
  createProjectNavProps: [],
  trendAnalysisFlag: [0],
  personaFlag: [0],
  chatbotFlag: [0],
  exportFlag: [0],
  chatbotExportFlag: [0],
  chatbotCopyFlag: [0]
}

const projectDetailsSlice = createSlice({
  name: 'projectDetails',
  initialState,
  reducers: {
    setClientName: (state, action) => {
      state.clientName = action.payload
    },
    setHasUsers: (state, action) => {
      state.hasUsers = action.payload
    },
    setJurisdiction: (state, action) => {
      state.jurisdiction = action.payload
    },
    setHealthCondition: (state, action) => {
      state.healthCondition = action.payload
    },
    setSdohData: (state, action) => {
      state.sdohData = action.payload
    },
    setIsCompleted: (state, action) => {
      state.isCompleted = action.payload
    },
    setProjectNamesList: (state, action) => {
      state.projectNamesList = action.payload
    },
    setNavigationProps: (state, action) => {
      state.navigationProps = action.payload
    },
    setCreateProjectNavProps: (state, action) => {
      state.createProjectNavProps = action.payload
    },
    setTrendAnalysisFlag: (state, action) => {
      state.trendAnalysisFlag = action.payload
    },
    setPersonaFlag: (state, action) => {
      state.personaFlag = action.payload
    },
    setChatbotFlag: (state, action) => {
      state.chatbotFlag = action.payload
    },
    setExportFlag: (state, action) => {
      state.exportFlag = action.payload
    },
    setChatbotExportFlag: (state, action) => {
      state.chatbotExportFlag = action.payload
    },
    setChatbotCopyFlag: (state, action) => {
      state.chatbotCopyFlag = action.payload
    },
    resetProjectDetails: () => initialState
  }
})

export const {
  setClientName,
  setHasUsers,
  setJurisdiction,
  setHealthCondition,
  setSdohData,
  setIsCompleted,
  setProjectNamesList,
  setNavigationProps,
  setCreateProjectNavProps,
  setTrendAnalysisFlag,
  setPersonaFlag,
  setChatbotFlag,
  setExportFlag,
  setChatbotExportFlag,
  setChatbotCopyFlag,
  resetProjectDetails
} = projectDetailsSlice.actions

// Selectors
export const selectClientName = (state) => state.projectDetails.clientName
export const selectHasUsers = (state) => state.projectDetails.hasUsers
export const selectJurisdiction = (state) => state.projectDetails.jurisdiction
export const selectHealthCondition = (state) => state.projectDetails.healthCondition
export const selectSdohData = (state) => state.projectDetails.sdohData
export const selectIsCompleted = (state) => state.projectDetails.isCompleted
export const selectProjectNamesList = (state) => state.projectDetails.projectNamesList
export const selectNavigationProps = (state) => state.projectDetails.navigationProps
export const selectCreateProjectNavProps = (state) => state.projectDetails.createProjectNavProps
export const selectTrendAnalysisFlag = (state) => state.projectDetails.trendAnalysisFlag
export const selectPersonaFlag = (state) => state.projectDetails.personaFlag
export const selectChatbotFlag = (state) => state.projectDetails.chatbotFlag
export const selectExportFlag = (state) => state.projectDetails.exportFlag
export const selectChatbotExportFlag = (state) => state.projectDetails.chatbotExportFlag
export const selectChatbotCopyFlag = (state) => state.projectDetails.chatbotCopyFlag

export default projectDetailsSlice.reducer
